import { IntlShape } from 'react-intl'

import { VAT_STATUS } from '../../components'

export const vatStatusToLabel = ({
  vatStatus,
  intl,
}: {
  vatStatus: VAT_STATUS
  intl: IntlShape
}) => {
  switch (vatStatus) {
    case VAT_STATUS.HT:
      return intl.formatMessage({
        id: 'ui.vatStatusToLabel.HT',
        defaultMessage: 'HT',
      })
    case VAT_STATUS.TTC:
      return intl.formatMessage({
        id: 'ui.vatStatusToLabel.TTC',
        defaultMessage: 'TTC',
      })
  }
}
